import NarrowInfoView from "../NarrowInfoView";
import TwoSidedView from "../TwoSidedView";
import Paragraphs from "../Paragraphs";

function PickupLocation({ title, paragraphs, abholort }) {
    return (
        <NarrowInfoView
            title={title}
            content={
                <div>
                    {paragraphs && <Paragraphs paragraphs={paragraphs} />}
                    {abholort && (
                        <div className="mt-8 mb-2">
                            <TwoSidedView
                                left={
                                    <div>
                                        <div>{abholort.name}</div>
                                        <div>{abholort.adresse}</div>
                                        <br />
                                        <div>{abholort.oeffnungszeiten}</div>
                                    </div>
                                }
                                right={
                                    <div>
                                        <div>Telefonnummer:</div>
                                        <div>{abholort.telefon}</div>
                                        <br />
                                        <div>Email-Adresse:</div>
                                        <div>
                                            <a href={`mailto:${abholort.email}`}>{abholort.email}</a>
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                    )}
                </div>
            }
        />
    );
}

export default PickupLocation;
